import { combineReducers } from 'redux';
import {
  FETCH_CONTACT_PROFILE_INFO_SUCCESS,
  FETCH_CONTACT_PROFILE_INFO_FAILURE,
  FETCH_AGENT_PORTAL_PROFILE_INFO_SUCCESS,
  FETCH_AGENT_PORTAL_PROFILE_INFO_FAILURE,
  FETCH_BACKGROUND_CHECK_INFO_SUCCESS,
  FETCH_BACKGROUND_CHECK_INFO_FAILURE,
  FETCH_SUBPRODUCERS_INFO_SUCCESS,
  FETCH_SUBPRODUCERS_INFO_FAILURE,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  RESET_CONTACT_PROFILE_STATE,
  RESET_AGENT_PROFILE_STATE,
  RESET_SUBPRODUCERS_STATE,
  RESET_PRODUCTS_STATE,
  SET_PREFERENCES_STATE,
  SET_CUSTOM_ENROLLMENTS_STATE,
  SET_AGENTS_STATE,
  SET_CUSTOM_LINKS_STATE,
  SET_LOADING_STATE,
  SET_CURRENT_USER_STATE,
  SET_WEB_ALERTS_STATE,
  SET_CRITICAL_BANNER_STATE,
  SET_FROM_SIGNUP,
  SET_FROM_FEDERATION,
  SET_AGENCY_ID,
} from '../actions/actions';


const pick = (obj = {}, keys = []) =>
  keys.reduce((acc, k) => {
    if (obj && Object.prototype.hasOwnProperty.call(obj, k)) {
      acc[k] = obj[k];
      return acc;
    }
  }, {});

const mapPick = (arr, keys) => (Array.isArray(arr) ? arr.map((x) => pick(x, keys)) : []);


const contactProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case RESET_CONTACT_PROFILE_STATE: 
      return { ...state.contact, ...{} };
    case FETCH_CONTACT_PROFILE_INFO_SUCCESS:
      return { ...state, ...pick(action.payload, ['emailAddress', 'contactId', 'firstName', 'lastName']) };
    case FETCH_CONTACT_PROFILE_INFO_FAILURE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const selectedProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case RESET_AGENT_PROFILE_STATE: 
      return { ...state.selectedProfile, ...{} };
    case FETCH_AGENT_PORTAL_PROFILE_INFO_SUCCESS:
      return { ...state.selectedProfile, ...pick(action.payload, ['amsuitePreference', 'lpId']) };
    case FETCH_AGENT_PORTAL_PROFILE_INFO_FAILURE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const backgroundCheckReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_BACKGROUND_CHECK_INFO_SUCCESS:
      return { ...state.background, ...action.payload };
    case FETCH_BACKGROUND_CHECK_INFO_FAILURE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const subproducersReducer = (state = [], action) => {
  switch (action.type) {
    case RESET_SUBPRODUCERS_STATE:
      return { ...state.subproducers, ...[] };
    case FETCH_SUBPRODUCERS_INFO_SUCCESS:
          return mapPick(action.payload, ['mAgentCd', 'mSubproducerCd', 'mDisplayName', 'managingGroupName']);
      case FETCH_SUBPRODUCERS_INFO_FAILURE:
      return { ...state,  ...action.payload };
    default:
      return state;
  }
};

const productsReducer = (state = {}, action) => {
  switch (action.type) {
    case RESET_PRODUCTS_STATE:
      return { ...state.products, ...{} };
    case FETCH_PRODUCTS_SUCCESS:
      return mapPick(action.payload, ['description', 'productCode', 'sectionCode']);
    case FETCH_PRODUCTS_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

const preferencesReducer = (state = [], action) => {
  switch (action.type) {
    case SET_PREFERENCES_STATE:
      return action.payload;
    default:
      return state;
  }
};

const enrollmentsReducer = (state = [], action) => {
  switch (action.type) {
    case SET_CUSTOM_ENROLLMENTS_STATE:
      return mapPick(action.payload, ['is_default', 'prismId', 'domain', 'guid', 'isCurrent']);
    default:
      return state;
  }
};

const agentsReducer = (state = [], action) => {
  switch (action.type) {
    case SET_AGENTS_STATE:
      return mapPick(action.payload, ['mAgentCd', 'mDisplayName', 'managingGroupName']);
    default:
      return state;
  }
}

const customLinksReducer = (state = [], action) => {
  switch (action.type) {
    case SET_CUSTOM_LINKS_STATE:
      return action.payload;
    default:
      return state;
  }
};

const loadingReducer = (state = false, action) => {
  switch (action.type) {
    case SET_LOADING_STATE:
      return action.payload;
    default:
      return state;
  }
};

const currentUserReducer = (state = null, action) => {
  switch (action.type) {
    case SET_CURRENT_USER_STATE:
      return action.payload;
    default:
      return state;
  }
};

const webAlertsReducer = (state = [], action) => {
  switch (action.type) {
    case SET_WEB_ALERTS_STATE:
      return action.payload;
    default:
      return state;
  }
};

const criticalBannerStateReducer = (state = true, action) => {
  switch (action.type) {
    case SET_CRITICAL_BANNER_STATE:
      return action.payload;
    default:
      return state;
  }
};

const fromSignupReducer = (state = null, action) => {
  switch (action.type) {
    case SET_FROM_SIGNUP:
      return action.payload;
    default:
      return state;
  }
};

const fromFederationReducer = (state = null, action) => {
  switch (action.type) {
    case SET_FROM_FEDERATION:
      return action.payload;
    default:
      return state;
  }
};

const agencyIdReducer = (state = null, action) => {
  switch (action.type) {
    case SET_AGENCY_ID:
      return action.payload;
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  contact: contactProfileReducer,
  selectedProfile: selectedProfileReducer,
  preferences: preferencesReducer,
  enrollments: enrollmentsReducer,
  agents: agentsReducer,
  background: backgroundCheckReducer,
  subproducers: subproducersReducer,
  products: productsReducer,
  customLinks: customLinksReducer,
  loading: loadingReducer,
  currentUser: currentUserReducer,
  webAlerts: webAlertsReducer,
  criticalBannerState: criticalBannerStateReducer,
  fromSignup: fromSignupReducer,
  fromFederation: fromFederationReducer,
  agencyId: agencyIdReducer,
});

export default rootReducer;
